import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import http from 'http'

import { AiOutlineClear } from 'react-icons/ai'

const ByProperty = ( {
  fieldName,
  state
} ) => {
  const [ searchParams ] = useSearchParams()
  const [ list, setList ] = state

  useEffect( () => {
    http( {
      method: 'GET',
      url: '/track/distinct',
      params: {
        field: fieldName
      }
    } )
      .then( ( { data } ) => {
        let d = data.map( i => ( { name: i, selected: false } ) )

        const w = searchParams.get( fieldName )

        if ( w ) {
          ( JSON.parse( w ) )
            .forEach( i => {
              const index = d.findIndex( j => j.name === i )

              d[ index ].selected = true
            } )
        }

        setList( d )
      } )
  }, [] )

  const toggleStatus = ( update, index ) => {
    update( items => {
      const aux = [ ...items ]

      aux[ index ].selected = ! aux[ index ].selected

      return [ ...aux ]
    } )
  }

  const clear = ( update ) => {
    update( items => {
      const aux = [ ...items ]

      return aux
        .map( i => ( { ...i, selected: false } ) )
    } )
  }

  if ( list.length === 0 )
    return null

  return <div className="hs air-2x gap-2x">
    <div className="hs gap-2x">
      <div className="vs bar">
        <h1 className="one size-2x8">{ fieldName }</h1>

        <button
          title="clear"
          onClick={ () => clear( setList ) }
        >
          <AiOutlineClear />
        </button>
      </div>

      <div className="vs wrap in-air-2x gap-2x bg-secondary br check-buttons">
        { list.map( ( item, index ) => <button
          key={ index }
          className={ `${ item.selected ? 'selected' : '' }` }
          onClick={ () => toggleStatus( setList, index ) }
        >
          { item.name || `without ${ fieldName }` }
        </button> ) }
      </div>
    </div>
  </div>
}

export default ByProperty
